export const crossDeviceDividerMap = {
    divider2: 'b49ee3_705ace29f9cb4733803cf482c9a9e430~mv2.png',
    divider3: 'b49ee3_9fb628fa334a4e9684d818b9486b16de~mv2.png',
    divider4: 'b49ee3_4a3326c44974463e8e1c99383219bf93~mv2.png',
    divider7: 'b49ee3_0226615deeb843bebeae637ead4b1871~mv2.png',
    divider8: 'a306cb_6d2e0e5aa9f5498a8ce56a7af4e8aae0~mv2.png',
    divider11: 'a306cb_dcbe4514b752457a8667df748d5e94c3~mv2.png',
    divider12: 'a306cb_e18280ddaf424d1396a3681164f1ced7~mv2.png',
    divider13: 'a306cb_1f2e51ab86634d989140cc0083b2b121~mv2.png',
    divider14: 'a306cb_3d2c01641d3e44db820b987d9be43503~mv2.png',
    divider15: 'b49ee3_b1d04af02c8c47ca9b58205d16225b0a~mv2.png',
    divider16: 'a306cb_19e26715e49040bea4dcc5be3793a14d~mv2.png',
    divider17: 'a306cb_89d990146595403da8f2d55335f1c361~mv2.png',
};
export const dividerWidthMap = {
    divider8: 50,
    divider11: 84,
    divider12: 31,
    divider13: 72,
    divider14: 33,
    divider16: 334,
    divider17: 33,
};
export const dividerHeightMap = {
    divider2: 2,
    divider3: 2,
    divider4: 7,
    divider7: 15,
    divider8: 30,
    divider11: 14,
    divider12: 35,
    divider13: 10,
    divider14: 18,
    divider15: 13,
    divider16: 10,
    divider17: 30,
};
export const defaultWidth = 700;
export const defaultHeight = 40;
//# sourceMappingURL=divider-map.js.map